import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { API_GEO_DATA_URL } from "constants/config"
import { authBaseQuery } from "../api"

if (!API_GEO_DATA_URL) {
  throw new Error("REACT_APP_API_CORE_URL is not defined")
}

export const geoDataApi = createApi({
  reducerPath: "geoDataApi",
  baseQuery: authBaseQuery(API_GEO_DATA_URL),
  endpoints: () => ({}),
})
